module.exports = __webpack_public_path__ + "img/miandian.8711ee3a.webp";